

































































import { Component, Prop, Vue } from 'vue-property-decorator'
import BillboardFileViewer from '../billboard-file-viewer/BillboardFileViewer.vue'

@Component({
  name: 'BillboardPreview',
  components: {
    BillboardFileViewer
  }
})
export default class BillboardPreview extends Vue {
  @Prop({ required: false }) id: any
  @Prop({ required: false }) changeFile: boolean
  @Prop({ required: false }) title: string
  @Prop({ required: false }) message: string
  @Prop({ required: false }) file: string
  @Prop({ required: false }) url: string
  @Prop({ required: false }) fileForPreview: File

  @Prop() width: number
  @Prop() height: number

  public readonly DEFAULT_WIDTH = 600
  public readonly DEFAULT_HEIGHT = 315

  $refs: {
    portlet: HTMLDivElement
  }

  spans: number

  data() {
    return {
      spans: 0
    }
  }

  onDisplayed() {
    this.setSpans()
  }

  get getSpans() {
    return `span ${this.spans}`
  }

  setSpans() {
    let height = this.$refs.portlet.clientHeight
    this.spans = Math.ceil(height / 25)
  }

  getFormatedUrl(url) {
    const youtube =
      /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
    const vimeo =
      /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i

    if (url) {
      if (url.match(youtube)) {
        return `https://www.youtube.com/embed/${url.match(youtube)[1]}`
      } else if (url.match(vimeo)) {
        return `https://player.vimeo.com/video/${
          url.match(vimeo)[1]
        }?color=5cd7d4&byline=0&portrait=0`
      } else {
        console.log(this.$t('message.billboard.errors.invalidUrl'))
      }
    }
  }
}
